import React from "react";
import ReactECharts from "echarts-for-react";

const ProsumerDashboardBarChart: React.FC = () => {
  const data = [
    { day: "Thu", usage: 67 },
    { day: "Fri", usage: 20 },
    { day: "Sat", usage: 40 },
    { day: "Sun", usage: 90 },
    { day: "Mon", usage: 50 },
    { day: "Tue", usage: 5 },
    { day: "Wed", usage: 45 },
  ];

  const days = data.map((item) => item.day);
  const usages = data.map((item) => item.usage);

  const options = {
    tooltip: {
      trigger: "axis",
      backgroundColor: "#181B25",
      borderWidth: 0,
      textStyle: {
        color: "#fff",
        fontSize: 12,
      },
      axisPointer: {
        type: "shadow",
      },
      formatter: (params: any) => {
        const [data] = params;
        return `<div style="padding: 5px;">
            <strong>${data.axisValue}</strong><br/>
            Usage: ${data.data} kWh
          </div>`;
      },
    },
    xAxis: {
      type: "category",
      data: days,
      axisLabel: {
        color: "#181B25",
        fontSize: 11,
        fontWeight: 400,
      },
    },
    yAxis: {
      type: "value",
      min: 0,
      max: 120,
      interval: 30,
      name: "kWh",
      nameLocation: "end",
      axisLabel: {
        formatter: "{value}",
        color: "#5F6368",
        fontSize: 9,
        fontWeight: 400,
        lineHeight: 11,
        letterSpacing: 0.2,
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: "#e0e0e0",
          type: "dashed",
        },
      },
    },
    legend: {
      textStyle: {
        fontSize: 10,
        color: "#5F6368",
      },
      itemStyle: {
        color: "#1976d2",
      },
    },
    series: [
      {
        name: "Usage",
        data: usages,
        type: "bar",
        itemStyle: {
          color: (params: any) =>
            params.dataIndex === 3 ? "#1976d2" : "#d9d9d9",
        },
        barWidth: "40%",
      },
    ],
    grid: {
      left: "5%",
      right: "5%",
      bottom: "10%",
      containLabel: true,
    },
  };

  return (
    <ReactECharts option={options} style={{ height: "400px", width: "100%" }} />
  );
};

export default ProsumerDashboardBarChart;
